import { render } from "./SkeletonButton.vue?vue&type=template&id=0031bf6c"
import script from "./SkeletonButton.vue?vue&type=script&lang=js"
export * from "./SkeletonButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__